import React, { useState, useEffect } from 'react';
// import styles from "./LoginRegister.scss";
import { IPropertyWizardInput } from './NewPropertyWizard';
import useUser, { IUserState } from '../../stores/useUser';
import styles from './NewPropertyWizard.scss';
import Owner from '../../utils/Owner';
import LoginRegisterToggle from '../LoginRegisterToggle';
import { IProperty } from '../../utils/JsonApiRequest';
import { IWglEventProps } from '../../utils/trackApi';

export interface ILoginRegisterProps extends IPropertyWizardInput {
    // text: string;
    data: IProperty;
    trackingEvent?: IWglEventProps;
}

const LoginRegister: React.FC<React.PropsWithChildren<ILoginRegisterProps>> = ({ data = null, step = null, onChange = () => { }, trackingEvent }) => {
    const [user, userActions] = useUser();
    const [isLogin, setIsLogin] = useState(false);

    useEffect(() => {
        if (!data.contact) {
            Owner(user.id)
                .getContact()
                .then((data) => {
                    onChange('contact', data);
                });
        }
        onChange('loggedIn', user.isLoggedIn);
    }, [user]);

    // const handleChange = (ev: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
    //     onChange(ev.target.name as keyof IProperty, ev.target.value);
    // };

    const handleRegister = () => {
        onChange('loggedIn', true);
    };

    return (
        <div className={styles.loginRegister}>
            {user.isLoggedIn ? (
                <div>Eingeloggt als {user.name}</div>
            ) : (
                <>
                    {isLogin ? (
                        <>
                            <p>
                                <a
                                    onClick={() => {
                                        setIsLogin(false);
                                    }}
                                >
                                    » Neues Wohnglück-Konto registrieren
                                </a>
                            </p>
                            {/* <LoginForm successHandler={handleRegister} /> */}
                            {/* <LoginRegisterToggle showMinimal={true} defaultForm="login" /> */}
                        </>
                    ) : (
                        <>
                            <p><a
                                onClick={() => {
                                    setIsLogin(true);
                                }}
                            >
                                » Mit bestehendem Wohnglück-Konto anmelden
                            </a></p>
                            <p>
                                oder <b>neu Registrieren</b>:
                            </p>
                            {/* <RegisterForm successHandler={handleRegister} /> */}
                        </>
                    )}
                    <LoginRegisterToggle className={isLogin ? styles.login : styles.register} showMinimal={true} defaultForm={isLogin ? 'login' : 'register'} trackingEvent={trackingEvent} />
                </>
            )}
        </div>
    );
};

export default LoginRegister;
